import React from 'react';
import fetch from 'common/services/fetch';
import store from 'common/services/storage';
import utils from 'common/utils';
import toast from 'components/mtToast/mtToast';
import './cangoManage.scss';

/**
 * 供应商 H5 场次成团管理页。
 * 用于承接公众号模板消息跳转后的单场次成团查看与操作。
 */
class CangoManageView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      detail: null,
      modalType: '',
      gapInputValue: '',
    };
    this.loadDetail = this.loadDetail.bind(this);
    this.openFinishModal = this.openFinishModal.bind(this);
    this.openGapModal = this.openGapModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleGapInputChange = this.handleGapInputChange.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.finishCango = this.finishCango.bind(this);
    this.saveGap = this.saveGap.bind(this);
    document.title = '麦淘供应商';
  }

  componentDidMount() {
    this.loadDetail();
  }

  /**
   * 获取当前场次成团详情。
   */
  loadDetail() {
    const actItemId = utils.getUrlParam('actItemId');
    const partnerId = store.get(store.LOGIN_UID);
    if (utils.isEmpty(actItemId)) {
      toast.pop('缺少场次参数');
      this.setState({
        loading: false,
      });
      return;
    }
    if (utils.isEmpty(partnerId)) {
      toast.pop('缺少供应商身份');
      this.setState({
        loading: false,
      });
      return;
    }
    this.setState({ loading: true });
    fetch.get('/partner/bend/cango/detail', { actItemId, partnerId }).then((res) => {
      this.setState({
        loading: false,
        detail: res,
      });
    }).catch(() => {
      this.setState({
        loading: false,
      });
    });
  }

  /**
   * 打开“设为已成团”确认弹窗。
   */
  openFinishModal() {
    const { detail } = this.state;
    if (!detail) {
      return;
    }
    this.setState({
      modalType: 'finish',
    });
  }

  /**
   * 打开“更新成团差额数”弹窗。
   * 直接回显后端返回的真实差额值，避免页面展示值与实际提交值不一致。
   */
  openGapModal() {
    const { detail } = this.state;
    if (!detail) {
      return;
    }
    this.setState({
      modalType: 'gap',
      gapInputValue: this.getInitialGapValue(detail),
    });
  }

  /**
   * 关闭当前弹窗并重置临时输入值。
   */
  closeModal() {
    this.setState({
      modalType: '',
      gapInputValue: '',
    });
  }

  /**
   * 处理差额输入，仅保留正整数文本。
   * @param {Object} e 输入事件
   */
  handleGapInputChange(e) {
    const value = String(e.target.value || '').replace(/[^\d]/g, '');
    this.setState({
      gapInputValue: value,
    });
  }

  /**
   * 顶部返回按钮，优先回退浏览历史。
   */
  handleBack() {
    if (window.history.length > 1) {
      window.history.back();
      return;
    }
    window.location.replace('/');
  }

  /**
   * 调用后端完成场次已成团设置。
   */
  finishCango() {
    const { detail } = this.state;
    const partnerId = store.get(store.LOGIN_UID);
    if (!detail) {
      return;
    }
    fetch.post('/partner/bend/cango/finish', { actItemId: detail.actItemId, partnerId }, { loading: true }).then(() => {
      toast.pop('操作成功');
      this.closeModal();
      this.loadDetail();
    });
  }

  /**
   * 保存供应商手动设置的差额人数。
   * @param {string|number} gapValue 输入的差额值
   */
  saveGap(gapValue) {
    const { detail } = this.state;
    const partnerId = store.get(store.LOGIN_UID);
    if (!detail) {
      return;
    }
    const parsedValue = parseInt(gapValue, 10);
    if (!parsedValue || parsedValue < 1) {
      toast.pop('请输入大于等于1的差额数');
      return;
    }
    fetch.post('/partner/bend/cango/saveGap', {
      actItemId: detail.actItemId,
      gapCount: parsedValue,
      partnerId,
    }, { loading: true }).then(() => {
      toast.pop('操作成功');
      this.closeModal();
      this.loadDetail();
    });
  }

  /**
   * 计算差额输入框的初始值，保证至少回显为 1。
   * @param {Object} detail 场次成团详情
   * @returns {string} 前端受控输入框的默认值
   */
  getInitialGapValue(detail) {
    const currentGap = parseInt(detail.gapCount, 10);
    return String(currentGap > 0 ? currentGap : 1);
  }

  renderStatusText(detail) {
    if (!detail) {
      return '';
    }
    if (detail.statusReached) {
      return '该团期已达成团标准，请24小时内更新成团结果';
    }
    return `该团期现差${detail.gapCount}${detail.unitText}成团`;
  }

  /**
   * 渲染页面字段行。
   * @param {string} label 左侧字段名
   * @param {string} value 右侧字段值
   * @returns {JSX.Element} 信息行节点
   */
  renderInfoRow(label, value) {
    return (
      <div className='infoRow'>
        <div className='infoLabel'>{label}</div>
        <div className='infoValue'>{value || '-'}</div>
      </div>
    );
  }

  /**
   * 渲染页面底部弹窗。
   * @returns {JSX.Element|null} 弹窗节点
   */
  renderModal() {
    const { detail, modalType, gapInputValue } = this.state;
    if (!detail || !modalType) {
      return null;
    }
    const isGapModal = modalType === 'gap';
    const currentGap = parseInt(detail.gapCount, 10);
    const gapPrefix =
      detail.statusReached || currentGap <= 0
        ? '该团期现已达成团标准，修改为差'
        : `该团期现差${detail.gapCount}${detail.unitText}成团，修改为差`;
    return (
      <div className='modalMask' onClick={this.closeModal}>
        <div className='modalPanel' onClick={(e) => e.stopPropagation()}>
          <div className='modalClose' onClick={this.closeModal}>×</div>
          <div className='modalTitle'>{isGapModal ? '差额数更新' : '设为已成团'}</div>
          <div className='modalRow modalRowStrong'>
            <span className='modalLabel modalLabelStrong'>场次名称:</span>
            <span className='modalValue modalValueStrong'>{detail.actItemTitle}</span>
          </div>
          {
            isGapModal ?
              <div className='modalDesc'>
                <div className='modalGapLine'>
                  <span>{gapPrefix}</span>
                  <input
                    className='modalGapInput'
                    type='tel'
                    inputMode='numeric'
                    value={gapInputValue}
                    onChange={this.handleGapInputChange}
                  />
                  <span className='modalGapSuffix'>{detail.unitText}成团</span>
                </div>
              </div> :
              <div className='modalDesc'>设为已成团，将给客户发送成团短信，且此操作不可逆，确定继续操作吗？</div>
          }
          <div className='modalActions'>
            <div className='modalActionBtn secondary' onClick={this.closeModal}>取消</div>
            <div
              className='modalActionBtn primary'
              onClick={isGapModal ? () => this.saveGap(gapInputValue) : this.finishCango}>
              确定
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { loading, detail } = this.state;
    if (loading) {
      return <div className='cangoManageView'><div className='loading'>加载中...</div></div>;
    }
    if (!detail) {
      return <div className='cangoManageView'><div className='empty'>暂无成团信息</div></div>;
    }
    const visibleButtonCount = [detail.canSaveGap, detail.canFinish].filter(Boolean).length;
    return (
      <div className='cangoManageView'>
        <div className='pageHeader'>
          <div className='headerBack' onClick={this.handleBack}>
            <span className='headerBackIcon' />
          </div>
          <div className='headerTitle'>麦淘供应商</div>
          <div className='headerPlaceholder' />
        </div>

        <div className='pageContent'>
          <div className='productTitle'>{detail.productTitle}</div>
          <div className='ruleLine'>
            <span className='ruleLabel'>成团规则：</span>
            <span className='ruleValue'>{detail.standardText}</span>
          </div>
          <div className='infoSection'>
            {this.renderInfoRow('场次名称:', detail.actItemTitle)}
            {this.renderInfoRow('麦淘已收:', detail.cangoProgressText)}
          </div>
          <div className={`statusBanner ${detail.statusReached ? 'reached' : ''}`}>
            {this.renderStatusText(detail)}
          </div>
        </div>

        {
          visibleButtonCount > 0 &&
            <div className={`bottomActionBar ${visibleButtonCount === 1 ? 'single' : ''}`}>
              {
                detail.canSaveGap &&
                <div className='actionBtn secondary' onClick={this.openGapModal}>更新成团差额数</div>
              }
              {
                detail.canFinish &&
                <div className='actionBtn primary' onClick={this.openFinishModal}>设为已成团</div>
              }
            </div>
        }
        {this.renderModal()}
      </div>
    );
  }
}

export default CangoManageView;
